import {
  bindable,
  inject,
  ComponentAttached,
  ComponentDetached,
} from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { DropzoneOptions, DropzoneFile } from "dropzone";
import "dropzone/dist/min/dropzone.min.css";
import "./k-upload.css";
import Dropzone from "dropzone";

@inject(I18N)
export class KUpload implements ComponentAttached, ComponentDetached {
  @bindable options: DropzoneOptions;
  dropzoneElement: HTMLElement;
  successFiles: DropzoneFile[] = [];
  errorFiles: DropzoneFile[] = [];

  private defaultOptions: DropzoneOptions;
  private dropzone: Dropzone;

  constructor(private i18n: I18N) {
    let i18noptions = { interpolation: { prefix: "__" } };
    this.defaultOptions = {
      url: "./upload",
      parallelUploads: 4,
      maxFiles: 100,
      maxFilesize: 10 /*MB*/,
      uploadMultiple: false,
      addRemoveLinks: true,
      autoProcessQueue: false,
      dictDefaultMessage: i18n.tr(
        "components.k-upload.defaultMessage",
        i18noptions,
      ),
      dictFileTooBig: i18n.tr("components.k-upload.fileTooBig", i18noptions),
      dictResponseError: i18n.tr(
        "components.k-upload.responseError",
        i18noptions,
      ),
      dictMaxFilesExceeded: i18n.tr(
        "components.k-upload.maxFilesExceeded",
        i18noptions,
      ),
      dictRemoveFile: i18n.tr("components.k-upload.removeFile", i18noptions),
      dictCancelUpload: i18n.tr(
        "components.k-upload.cancelUpload",
        i18noptions,
      ),
      dictCancelUploadConfirmation: i18n.tr(
        "components.k-upload.cancelUploadConfirmation",
        i18noptions,
      ),
    };
  }

  attached() {
    let dropzoneOptions = (<any>Object).assign(
      {},
      this.defaultOptions,
      this.options,
    );
    this.dropzone = new Dropzone(this.dropzoneElement, dropzoneOptions);
    this.dropzone.on("error", (file, response) => {
      this.errorFiles.push(file);
      this.dropzone.processQueue();
    });
    this.dropzone.on("success", (file, response) => {
      this.successFiles.push(file);
      this.dropzone.removeFile(file);
      this.dropzone.processQueue();
    });
  }

  detached() {
    if (this.dropzone) this.dropzone.destroy();
  }

  get hasFiles(): boolean {
    return this.dropzone && this.dropzone.files.length > 0;
  }

  get hasQueuedFiles(): boolean {
    return this.dropzone && this.dropzone.getQueuedFiles().length > 0;
  }

  submit() {
    this.dropzone.processQueue();
  }

  clearQueue() {
    this.dropzone.removeAllFiles();
    this.successFiles = [];
    this.errorFiles = [];
  }
}
